import { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningCircleIcon } from "@progress/kendo-svg-icons";

export default function NoDataPage(): ReactElement {
  const localizationService = useLocalization();

  return (
    <div className="w-full flex justify-center">
      <div className="gb-text-normal text-lg text-center w-full"
        style={{ 
          padding: '40px 25px'
        }}>
        <div className="text-center mb-5">
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <SvgIcon icon={warningCircleIcon} size="xxxlarge" />
          </span>
        </div>
        <div className="space-y-4">
          <div>{localizationService.toLanguageString('custom.noDataFound', enMessages.custom.noDataFound)}</div>
          <div>{localizationService.toLanguageString('custom.changeDateRangeAndPoint', enMessages.custom.changeDateRangeAndPoint)}</div>
        </div>
      </div>
    </div>
  );
}
